import { Icon, type IconProps } from './Icon';

export function Stamp(props: IconProps) {
  return (
    <Icon viewBox="115.5 3 22 22" strokeWidth={1.73107} {...props}>
      <path d="M126.368 16.157V10.3867" />
      <circle cx="126.368" cy="6.92406" r="3.46215" />
      <path d="M130.984 13.8486H133.292C134.392 13.8486 135.339 14.6252 135.555 15.7041L136.709 21.4743C136.845 22.1524 136.669 22.8555 136.231 23.3903C135.792 23.925 135.137 24.2351 134.446 24.2351H118.291C117.599 24.2351 116.944 23.925 116.506 23.3903C116.067 22.8555 115.892 22.1524 116.027 21.4743L117.181 15.7041C117.397 14.6252 118.344 13.8486 119.445 13.8486H121.752" />
      <path d="M122.329 19.619H130.407" />
    </Icon>
  );
}
